import React, {FC} from "react";
import {useCurrentShow} from "hooks";
import DefaultLogoExhibitor from "view/images/DefaultLogoExhibitor";
import Avatar from "view/components/Avatar";
import {IExhibitorPair} from "@evennt-tech/api-v2-core";
import useStyles from "../styles";

type Props = {
  exhibitorPair: IExhibitorPair;
};

const Logo: FC<Props> = ({exhibitorPair}) => {
  const [show] = useCurrentShow();
  const classes = useStyles({show});

  return exhibitorPair?.companyToShow?.company?.companyInfo?.logoFile ? (
    <Avatar
      alt="Exhibitor Logo"
      className={classes.logo}
      variant="square"
      src={exhibitorPair?.companyToShow?.company?.companyInfo?.logoFile?.url}
    />
  ) : (
    <DefaultLogoExhibitor />
  );
};

export default Logo;
